import homeView from './views/home';
import projectsView from './views/projects';
import singleNewsView from './views/single-news';
import aboutView from './views/about';
import serviceOverviewView from './views/service-overview';
import serviceView from './views/service';
import newsView from './views/news';
import singleProjectView from './views/single-project';
import singlePressView from './views/single-press';
import teamView from './views/team';
import contactView from './views/contact';
import awardsView from './views/awards';

export default [
	homeView,
	projectsView,
	singleNewsView,
	aboutView,
	serviceOverviewView,
	serviceView,
	newsView,
	singleProjectView,
	singlePressView,
	teamView,
	contactView,
	awardsView,
];
